module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "async",
      rawName: "v-async",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "summary-desk"
  }, [(_vm.aggregate) ? _c('div', {
    staticClass: "content-box-npadd"
  }, [_c('p', [_vm._v("Dados do agregador e veículo")]), _vm._v(" "), _c('div', {}, [_c('p', [_vm._v("Nome/Razão Social: "), _c('span', [_vm._v(_vm._s(_vm.aggregate.companyName))])]), _vm._v(" "), _c('p', [_vm._v("CPF/CNPJ: "), _c('span', [_vm._v(_vm._s(_vm._f("cpfCnpj")(_vm.aggregate.taxIdNumber)))])])]), _vm._v(" "), (_vm.aggregate.taxpayerTransportador) ? _c('div', {}, [_c('p', [_vm._v("Dados do transportador")]), _vm._v(" "), _c('div', {}, [_c('p', [_vm._v("Nome/Razão Social: "), _c('span', [_vm._v(_vm._s(_vm.aggregate.nomeTransportador))])]), _vm._v(" "), _c('p', [_vm._v("CPF/CNPJ: "), _c('span', [_vm._v(_vm._s(_vm._f("cpfCnpj")(_vm.aggregate.taxpayerTransportador)))])])])]) : _vm._e(), _vm._v(" "), _c('div', {}, [_c('p', [_vm._v("Placa: "), _c('span', [_vm._v(_vm._s(_vm.aggregate.plate))])]), _vm._v(" "), _c('p', [_vm._v("TAG N°: "), _c('span', [_vm._v(_vm._s(_vm.aggregate.tagSerialNumber))])]), _vm._v(" "), _c('p', [_vm._v("Modelo: "), _c('span', [_vm._v(_vm._s(_vm.aggregate.nodelName))])]), _vm._v(" "), _c('p', [_vm._v("Marca: "), _c('span', [_vm._v(_vm._s(_vm.aggregate.brandName))])]), _vm._v(" "), _c('p', [_vm._v("Eixos: "), _c('span', [_vm._v(_vm._s(_vm.aggregate.category))])])])]) : _vm._e(), _vm._v(" "), (_vm.showDetails) ? _c('div', {
    staticClass: "content-box-npadd"
  }, [_c('div', {
    staticClass: "toll-info-box"
  }, [_c('div', {}, [_c('div', {}, [_c('small', [_vm._v("De")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.origin.city))]), _vm._v(" "), _c('small', [_c('img', {
    attrs: {
      "src": "/static/icon-send.svg",
      "alt": "icon send"
    }
  }), _vm._v("\n                " + _vm._s(_vm.origin.state) + "\n              ")])]), _vm._v(" "), _c('div', {}, [_c('small', [_vm._v("para")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.destination.city))]), _vm._v(" "), _c('small', [_c('img', {
    attrs: {
      "src": "/static/icon-location.svg",
      "alt": "icon location"
    }
  }), _vm._v("\n                " + _vm._s(_vm.destination.state) + "\n              ")])])]), _vm._v(" "), _c('button', {
    staticClass: "no-btn",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        _vm.open = !_vm.open
      }
    }
  }, [_c('i', {
    staticClass: "icon-circle-right",
    class: !_vm.open ? 'open' : ''
  })]), _vm._v(" "), _c('div', {
    staticClass: "toll-info-box",
    style: ({
      display: 'flex',
      alignItems: 'left',
      justifyContent: 'space-between',
      width: '100%'
    })
  }, [_c('p', [_vm._v("\n              rota:\n              "), _c('span', [_vm._v(_vm._s(_vm.routeSelected.name))])]), _vm._v(" "), _c('p', [_vm._v("\n              distância:\n              "), _c('span', [_vm._v(_vm._s(_vm.routeSelected.totalDistance) + " KM")])]), _vm._v(" "), _c('p', [_vm._v("\n              valor:\n              "), _c('span', [_vm._v(_vm._s(_vm._f("cents")(_vm.priceTolls.totalValue)))])]), _vm._v(" "), _c('p', [_vm._v("\n              inicio:\n              "), _c('span', [_vm._v(" " + _vm._s(_vm._f("date")(_vm.routeSelected.startToll)))])]), _vm._v(" "), _c('p', [_vm._v("\n              expiração:\n              "), _c('span', [_vm._v(" " + _vm._s(_vm._f("date")(_vm.routeSelected.expirationToll)))])])])]), _vm._v(" "), _c('div', {
    staticClass: "table-toll-info",
    class: !_vm.open ? 'open' : ''
  }, [_c('table', {
    staticClass: "table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.priceTolls.tolls), function(p, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(p.praca))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(p.concessionaria))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm._f("cents")(p.price)))])])
  }), 0)])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "summary-mob"
  }, [(_vm.aggregate) ? _c('div', {
    staticClass: "content-box"
  }, [_c('p', {
    staticClass: "bold-600"
  }, [_vm._v("Dados do agregador e veículo")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "bold-600"
  }, [_vm._v("Razão Social: ")]), _c('br'), _vm._v("\n          " + _vm._s(_vm.aggregate.companyName) + "\n        ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "bold-600"
  }, [_vm._v("CPF/CNPJ: ")]), _vm._v("\n          " + _vm._s(_vm._f("cpfCnpj")(_vm.aggregate.taxIdNumber)) + "\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "inline margin-r10"
  }, [_c('span', {
    staticClass: "bold-600"
  }, [_vm._v("Placa: ")]), _vm._v("\n          " + _vm._s(_vm.aggregate.plate) + "\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "inline"
  }, [_c('span', {
    staticClass: "bold-600"
  }, [_vm._v("TAG N°: ")]), _vm._v("\n          " + _vm._s(_vm.aggregate.tagSerialNumber) + "\n        ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "bold-600"
  }, [_vm._v("Modelo: ")]), _vm._v("\n          " + _vm._s(_vm.aggregate.modelName) + "\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "inline margin-r10"
  }, [_c('span', {
    staticClass: "bold-600"
  }, [_vm._v("Marca: ")]), _vm._v("\n          " + _vm._s(_vm.aggregate.brandName) + "\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "inline"
  }, [_c('span', {
    staticClass: "bold-600"
  }, [_vm._v("Eixos: ")]), _vm._v("\n          " + _vm._s(_vm.aggregate.category) + "\n        ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content-box-npadd"
  }, [_c('div', {
    staticClass: "toll-info-box"
  }, [_c('div', {}, [_c('div', {}, [_c('small', [_vm._v("De")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.origin.city))]), _vm._v(" "), _c('small', [_c('img', {
    attrs: {
      "src": "/static/icon-send.svg",
      "alt": "icon send"
    }
  }), _vm._v("\n                " + _vm._s(_vm.origin.state) + "\n              ")])]), _vm._v(" "), _c('div', {}, [_c('small', [_vm._v("para")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.destination.city))]), _vm._v(" "), _c('small', [_c('img', {
    attrs: {
      "src": "/static/icon-location.svg",
      "alt": "icon location"
    }
  }), _vm._v("\n                " + _vm._s(_vm.destination.state) + "\n              ")])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {}, [_c('p', [_vm._v("\n              rota:\n              "), _c('span', [_vm._v(_vm._s(_vm.routeSelected.name))])]), _vm._v(" "), _c('p', [_vm._v("\n              distância:\n              "), _c('span', [_vm._v(_vm._s(_vm.routeSelected.totalDistance) + " KM")])]), _vm._v(" "), _c('p', [_vm._v("\n              valor:\n              "), _c('span', [_vm._v(_vm._s(_vm._f("cents")(_vm.priceTolls.totalValue)))])]), _vm._v(" "), _c('p', [_vm._v("\n              vencimento:\n              "), _c('span', [_vm._v(_vm._s(_vm._f("date")(_vm.routeSelected.expirationToll)))])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Praça de pedágio")]), _vm._v(" "), _c('th', [_vm._v("Concessionária")]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Valor")])])])
}]}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-22576d48!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/account/aggregate/modal/toll-ticket/summary.vue
// module id = 2065
// module chunks = 1